'use strict';

export default function PreviewGroupEditController(
  CreativeService,
  CreativeGroupService,
  DataService,
  FlashService,
  PreviewGroupService,
  $state,
  MixpanelService
) {
  var vm = this;
  vm.creativeService = CreativeService;
  vm.creativeGroupService = CreativeGroupService;
  vm.dataService = DataService;
  vm.toggleDemo = toggleDemo;
  vm.saveGroup = saveGroup;
  vm.demos = [];
  vm.existingCreatives = [];
  vm.goBack = goBack;
  vm.initializeCreatives = initializeCreatives;
  vm.setInitialCreative = setInitialCreative;

  if (DataService.userCreatives.length == 0) {
    DataService.updateUserCreatives()
      .then(initializeCreatives)
      .then(setInitialCreative);
  } else {
    setInitialCreative();
    initializeCreatives();
  }

  function setInitialCreative() {
    CreativeService.setCreative(DataService.userCreatives[0]);
  }

  function toggleDemo(previewId) {
    var index = vm.demos.indexOf(previewId);

    if (index === -1) {
      vm.demos.push(previewId);
    } else {
      vm.demos.splice(index, 1);
    }
  }

  function initializeCreatives() {
    PreviewGroupService.show($state.params.id).then(response => {
      response.data.creativePreviews.forEach(function(creative) {
        vm.demos.push(creative.id);
      });

      DataService.userCreatives.forEach(function(creative) {
        if (vm.demos.includes(creative.id)) {
          creative.checked = true;
        }
      });

      vm.name = response.data.name;
    });
  }

  function goBack() {
    window.history.back();
  }

  function successfulUpdate() {
    FlashService.push('success', 'Your group has been updated.');

    MixpanelService.track('Demo Group Updated', {
      demoGroupId: $state.params.id
    });

    $state.go('creativePreview.showPreviewGroup', {
      id: $state.params.id
    });
  }

  function failedUpdate() {
    FlashService.push('error', 'Something went wrong.');
  }

  function saveGroup() {
    var namePresent = vm.name && vm.name.length > 0;
    var group = $state.params.id;

    if (namePresent > 0 && vm.demos.length > 0) {
      PreviewGroupService.update(group, vm.demos, vm.name).then(
        successfulUpdate,
        failedUpdate
      );
    } else {
      FlashService.push(
        'error',
        'Please select at least 1 demo and name your group.'
      );
    }
  }

  return vm;
}

PreviewGroupEditController.$inject = [
  'CreativeService',
  'CreativeGroupService',
  'DataService',
  'FlashService',
  'PreviewGroupService',
  '$state',
  'MixpanelService'
];
